module.exports = __webpack_public_path__ + "img/486.7c55f2d4.png";